import React from "react";

interface ISearchButtonProps {
  history: any;
}

export default class SearchButton extends React.Component<ISearchButtonProps> {
  state: {
    searchFieldActive: boolean;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      searchFieldActive: false,
    };
  }

  render() {
    return (
      <a
        href="#"
        className={`d-flex bg-mustard align-self-stretch p-3 br-lg cta-box search-box${
          this.state.searchFieldActive ? " active" : ""
        }`}
      >
        <input
          type="search"
          className="search_input"
          placeholder="Suchen...."
          onFocus={() =>
            this.setState({ ...this.state, searchFieldActive: true })
          }
          onKeyUp={(ev: any) => {
            if (ev.keyCode === 13 && ev.target.value !== "") {
              this.props.history.push(
                "/suche?q=" + encodeURIComponent(ev.target.value)
              );
            }
          }}
          onBlur={(ev: any) => {
            if (ev.target.value === "") {
              this.setState({ ...this.state, searchFieldActive: false });
            }
          }}
        ></input>
        <div className="searchicon">
          <span className="icon-search fs-4 txt-white"></span>
        </div>
        <div className="searchhint align-self-center">
          <p className="mb-0 fs-125 fw-400 txt-white hideover">
            Rechnungen, Rezepte u. Belege
          </p>
          <p className="mb-0 fs-2 fw-500 ttup txt-white"> Suchen</p>
        </div>
      </a>
    );
  }
}
